import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Link, SpaceBetween, Header, Button,
    Container, Spinner, Alert,  Modal,
    ExpandableSection,
    CopyToClipboard,
    StatusIndicator
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import AccessDenied from '../../AccessDenied'
import WaitForPageAccess from '../../WaitForPageAccess'
import './history.scss'
import checkPageAccess, { checkIfPortalAdmin, checkIfSupportAdmin } from "../../checkPageAccess";
import { API, graphqlOperation } from 'aws-amplify';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { Storage } from 'aws-amplify';
import { setCurrentAppId } from '../../store/userAuthSlice';
import { queryFRISCOTransactionsByAppIdProcessIdIndex} from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import moment from 'moment';
import { FLEXICO_TEMPLATE_KEYS, PROCESS_KEYS } from './Constants';
import { convertEpochToPST } from '../Frisco/FilterUtilities';
import { configureFlexicoAppSync, configureFlexicoS3, configureFriscoS3, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isApprover, isUploaderAllowed } from './AccessUtilities';
import { getFlexicoTemplate, listFlexicoTransactionsByFlexId, listFlexicoTransactionsByFlexIdAll } from 'src/utilities/FlexicoAPIs';
import { getPreference, createPreference, updatePreference, listPreference } from 'src/utilities/AppSyncPlusAPIs';
import { CodeView } from '@amzn/awsui-code-view';
import { v4 as uuidv4 } from 'uuid';
import DownloadableFileListComponent from '../Templates/components/DownloadableFileListComponent';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDisplayName } from '../utils/displayNameUtils';
import appSettings from '../CorpReporting/app_settings';
import { isCorpAdmin } from '../Templates/Utils/Permissions';

const FlexicoHistory = (props) => {

    const userAuthenticationDetails = useAuth();
    const gridRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch()
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [items, setItems] = useState([]);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [flexicoTemplateData, setFlexicoTemplateData] = useState({})
    const [transactions, setTransactions] = useState([])
    const [parametersModalData, setParametersModalData] = useState('')
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId);
    const [parametersVisible, setParametersVisible] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [hasColumnChanges, setHasColumnChanges] = useState(false)
    const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false)
    const [isAdminUser, setIsAdminUser] = useState(false)
    const [fullPreferenceObject, setFullPreferenceObject] = useState(null)
    
    const [isSavingColumnPreferences, setIsSavingColumnPreferences] = useState(false)
    const [columnPreferenceError, setColumnPreferenceError] = useState("")
    const [columnPreferenceSuccess, setColumnPreferenceSuccess] = useState("")
    const [isResetting, setIsResetting] = useState(false)
    
    // const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const currentAppId = useSelector(
        (globalState) => globalState.auth.currentAppId
      );
    let { id: paramId } = useParams();
    let { fid: paramFid } = useParams();
    
    const id = props.id || paramId;
    const fid = props.fid || paramFid;
    const [backUrl, setBackUrl] = useState(null)

    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FLEXICO);

    useEffect(() => {
        configureFlexicoAppSync()
        configureFlexicoS3()
        loadData()
        setBackUrl(getParam('back'))
        if(id){
            dispatch(setCurrentAppId(id))
        }
        return () => {
            configureGenericS3()
        };
    }, []);

    useEffect(() => {
        if (fid) {
            loadColumnPreferences(
                (savedState) => {
                    if (savedState && savedState.length > 0) {
                        // Apply saved column order and visibility to columnDefs
                        const reorderedCols = savedState
                            .filter(col => !col.hide)
                            .map(savedCol => {
                                return defaultColumnDefs.find(defCol => defCol.field === savedCol.colId);
                            })
                            .filter(Boolean);
                        setColumnDefs(reorderedCols);
                    }
                },
                (error) => {
                    console.error('Error loading column preferences:', error);
                }
            );
        }
    }, [fid]);


    const getS3FolderPath = (item) => {
        let status = item.processingStatus.toLowerCase()
        switch (status) {
            case 'completed': return 'completed';
            case 'pending':
            case 'processing': return 'pending';
            default: return status
        }
    }

    const processIcon = props => (
        props.data.status === 'Completed' ?
            <Box>
                <Icon name='status-positive' variant='success' ></Icon>
            </Box>

            : <Box>
                <Icon name='status-in-progress' variant='normal' ></Icon>
            </Box>


    )

    const downloadRawFile= async (item) => {
        configureFlexicoS3()
        let fn = `${item.rawFilePath}`
        fn = fn.replace('flexico/','')
        let prefix = 'flexico/'
        /*
        If s3 object name has a space. S3 replaces it with a +. 
        However, if it has a space and +, s3 resolves the space as + hence there is a resolution conflict between + and ' '. 
        S3 also responds with by replacing + as %2B when the file is uploaded via storage. 
        So, we have to replace the + with space and then %2B as + which then creates a correct downloadable key format.
        */
        if(fn.includes('+') && fn.includes('%2B')){
            fn=fn.replaceAll('%2B', 'ABCPLUSTEMP')
        }
        fn=fn.replaceAll('+', ' ')
        const result = await Storage.get(decodeURIComponent(fn).replaceAll('ABCPLUSTEMP','+'), { level: 'public', customPrefix:{public:prefix}, expires: 60 });
        window.open(result);
    }

    // Check if string is null, undefined, or empty
    function isEmpty(str) {
        return (str == null || !str || str.length === 0 || str.trim() === '' || str.trim() === 'null');
    }

    const performDownload = async(fn) => {
        let files = fn.split(',')
        for(let i=0;i<files.length;i++){
            if(isEmpty(files[i])){
                continue
            }
            let filefn = files[i].replace('flexico/','')
            let prefix = 'flexico/'
            const result = await Storage.get(filefn, { level: 'public', customPrefix:{public:prefix}, expires: 60 });
            window.open(result);
        }
    }
    const downloadFile = async (item, key) => {
        configureFlexicoS3()
        let fn = `${item[key]}`
        performDownload(fn)
    }

    const downloadFileFromJSON = async (item, key) => {
        configureFlexicoS3()
        let results = item[key]
        let uris = []
        for(let i=0;i<results.length;i++){
            let opRef = JSON.parse(results[i])
            uris.push(opRef?.uri)
        }
        let uriString = uris.join(',')
        performDownload(uriString)
        
    }

    const gotoDetails = (data) => {
        history.push(`/flexico/file/${data.fileId}`)
        
    }
    
    const downloadIcon = props => (
        <>{
            (props.data.bucketName && props.data.filePath) ? <SpaceBetween size='m' direction='horizontal'>
                <ExpandableSection headerText={<Box>Download</Box>}
                    headerActions={
                        <Button
                            variant="inline-link"
                            onClick={() => {
                                    downloadFile(props.data, 'filePath')
                                }
                            }
                        >
                            All
                        </Button>
                    }
                >
                    <DownloadableFileListComponent filePaths={props?.data.filePath.split(',')} bucketName={props?.data.bucketName}></DownloadableFileListComponent>
                </ExpandableSection>
                <>
                {
                    props.data.rawFilePath ?
                     <Button
                variant='inline-link'
                onClick={() => {
                    downloadRawFile(props.data)
                }
                }> [Raw file] </Button>
                : ''
                }</>
            </SpaceBetween>:
            <></>
        }</>
    )

    const outputIcon = props => {
        let s3DownloadCount = 0
        let isQSReport = false
        if(props.data.bucketName && props.data.outputResultsS3){
            s3DownloadCount = s3DownloadCount + props.data.outputResultsS3.split(",").length
        }
        if(props.data.outputResults){
            for(let i=0;i<props.data.outputResults.length;i++){
                let data = JSON.parse(props.data.outputResults[i])
                if(data.type == 'S3'){
                    s3DownloadCount = s3DownloadCount + 1
                }else if(data.type == 'QUICKSIGHT'){
                    isQSReport=true
                }
            }
        }
        return <SpaceBetween direction='horizontal' size='s'> 
        {
            s3DownloadCount > 0 && 
            <ExpandableSection headerText={<Box>Download</Box>}
                    headerActions={
                        <Button
            variant='inline-link'
            onClick={() => {
                downloadFile(props.data, 'outputResultsS3')
                downloadFileFromJSON(props.data, 'outputResults')
            }
            }> All </Button>
                    }
                >
                    <DownloadableFileListComponent filePaths={props?.data?.outputResultsS3?.split(",")} bucketName={props?.data.bucketName} filePathsInJson={props.data.outputResults}></DownloadableFileListComponent>
                </ExpandableSection>
                
        }
        {
            isQSReport? <Button
            variant='inline-icon'
            iconName='view-full'
            onClick={() => {
                gotoDetails(props.data)
            }
            }> </Button>:
        <></>
        }
        </SpaceBetween>
    }

    const outputIconOld = props => (
        <>{
            (props.data.bucketName && props.data.outputResultsS3) ? 
            <Button
                variant='inline-icon'
                iconName={props.data?.outputResultsS3?.includes(',')? 'folder': 'download'}
                onClick={() => {
                    downloadFile(props.data, 'outputResultsS3')
                }
                }> </Button>:
            <></>
        }
        {
            (props.data.outputResults) ? 
            <Button
                variant='inline-icon'
                iconName='view-full'
                onClick={() => {
                    gotoDetails(props.data)
                }
                }> </Button>:
            <></>
        }
        </>
        
        
    )

    const epochToTimestamp = props => (
        <Box>{ convertEpochToPST(Number(props.data.uploadedTimestamp)) }</Box>
    )
    const epochToTimestampLastUpdatedTime = props => (
        <Box>{ convertEpochToPST(Number(props.data.lastUpdatedTimestamp)) }</Box>
    )
    const epochToTimestampJobModificationTime = props => (
        <Box>{ convertEpochToPST(Number(props.data.jobStatusModificationTimestamp)) }</Box>
    )

    const epochToTimestampApprovalRequestedTime = props => (
        props.data?.approvalRequestedTime?
        <Box>{ convertEpochToPST(Number(props.data?.approvalRequestedTime)) }</Box>:
        <Box></Box>
    )

    const epochToTimestampApprovalModificationTime = props => (
        props.data?.approvalModificationTime?
        <Box>{ convertEpochToPST(Number(props.data?.approvalModificationTime)) }</Box>:
        <Box></Box>
    )
    
    const processImg = (props) => (
        <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" +
              props.data.uploadedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.uploadedBy}
          >
            {props.data.uploadedBy}
          </a>
        </Box>
      );

    const  processImgApprovedBy = (props) => (
        props.data.approvedBy ? <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" +
              props.data.approvedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.approvedBy}
          >
            {props.data.approvedBy}
          </a>
        </Box> : <Box></Box>
      );

    
    const parametersButton = (props) => {
        return props.data?.parameters? <Button onClick={() => {
        setParametersVisible(true)
        setParametersModalData(JSON.stringify(JSON.parse(props.data?.parameters), 0, 2))
        setModalLoading(false)
        }}>view</Button>:''
    }

    const approvalStatusButton = (props) => {
        if (props?.data.approvalStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='orange_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='green_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='red_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='grey_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'NO APPROVAL') {
            return <span className='blue_badge' >{props.data.approvalStatus}</span>
        } else {
            if (props.data.approvalId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='blue_badge' >{props.data.approvalStatus}</span> </Link>
            } else {
                return <span className='blue_badge' >{props.data.approvalStatus}</span>
            }
        }
    }

    const reviewStatusButton = (props) => {
        if (props?.data.reviewStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='orange_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='green_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='red_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='grey_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'NO REVIEW') {
            return <span className='blue_badge' >{props.data.reviewStatus}</span>
        } else {
            if (props.data.reviewId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='blue_badge' >{props.data.reviewStatus}</span> </Link>
            } else if(props.data.reviewStatus) {
                return <span className='blue_badge' >{props.data.reviewStatus}</span>
            }else {
                return <span></span>
            }
        }
    }

    const postProcessingApprovalStatusButton = (props) => {
        if (props?.data.rippleApprovalStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='orange_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='green_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='red_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='grey_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'NO APPROVAL') {
            return <span className='blue_badge' >{props.data.rippleApprovalStatus}</span>
        } else {
            if (props.data.rippleApprovalId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='blue_badge' >{props.data.rippleApprovalStatus}</span> </Link>
            } else {
                return <span  >{props.data.rippleApprovalStatus || '-'}</span>
            }
        }
    }
    const fileDetails = props => (
         <>
            <CopyToClipboard
            copyButtonAriaLabel="Copy file id"
            copyErrorText="file id failed to copy"
            copySuccessText="file id copied"
            textToCopy={props.data.fileId}
            variant="icon"
            />
            <Link href={`/flexico/file/${props.data.fileId}`}>{props.data.fileId} </Link>
         </>
        )

    const getValueOrDefault = (params, field, defaultValue = "-") => {
        if (params.data == null) return '';
        return params.data[field] || defaultValue;
    };

    const getTimestampValue = (params, field) => {
        if (params.data == null) return '';
        return params.data?.[field] ? convertEpochToPST(Number(params.data[field])) : "-";
    };

    const getDirectTimestampValue = (params, field) => {
        if (params.data == null) return '';
        return convertEpochToPST(Number(params.data[field]));
    };

    const defaultColumnDefs = [
        { field: 'lastUpdatedTimestamp', width: '250px', headerName: 'Last updated', sortable: true,  cellRenderer: epochToTimestampLastUpdatedTime, resizable: true, valueGetter: (params) => getDirectTimestampValue(params, 'lastUpdatedTimestamp') },
        { field: 'uploadedTimestamp', width: '250px',  headerName: 'Uploaded time', sortable: true, cellRenderer: epochToTimestamp, resizable: true, valueGetter: (params) => getDirectTimestampValue(params, 'uploadedTimestamp') },
        { field: 'Input', width: '250px', autoHeight: true,cellRenderer: downloadIcon },
        { field: 'Output', width: '250px', autoHeight: true, cellRenderer: outputIcon },
        { field: 'uploadedBy', width: '150px', headerName: 'Uploaded by', cellRenderer:processImg, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'uploadedBy') },
        { field: 'status', width: '200px', headerName: 'Status', sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'status') },
        { field: 'notice', width: '200px', headerName: 'Notice', sortable: true, resizable: true },
        { field: 'approvalStatus', width: '200px', headerName: 'Approval status', cellRenderer:approvalStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'approvalStatus') },
        { field: 'approvalStatusPp', width: '200px', headerName: 'Post process Approval status', cellRenderer:postProcessingApprovalStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'rippleApprovalStatus') },
        { field: 'approvedBy', width: '150px', headerName: 'Approved by', cellRenderer:processImgApprovedBy, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'approvedBy') },
        { field: 'review', width: '200px', headerName: 'Review on results', cellRenderer:reviewStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'reviewStatus') },
        { field: 'approvalRequestedTime', width: '250px', headerName: 'Approval requested', cellRenderer: epochToTimestampApprovalRequestedTime,sortable: true, resizable: true, valueGetter: (params) => getTimestampValue(params, 'approvalRequestedTime') },
        { field: 'approvalModificationTime', width: '250px', headerName: 'Approval modification time',cellRenderer: epochToTimestampApprovalModificationTime, sortable: true, resizable: true, valueGetter: (params) => getTimestampValue(params, 'approvalModificationTime') },
        { field: 'jobStartTime', width: '250px', headerName: 'Job start time', sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'jobStartTime') },
        { field: 'parameters', width: '120px',  headerName: 'parameters',sortable: true, resizable: true, cellRenderer: parametersButton },
        { field: 'file id', width: '350px',cellRenderer: fileDetails,  headerName: 'file id',sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'fileId') },
    ];
    const [columnDefs, setColumnDefs] = useState(defaultColumnDefs)

    const defaultColDef = {
        // set filtering on for all columns
        filter: true,
        filterParams: {
            buttons: ["reset"],
            debounceMs: 200,
        }
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


    const checkAdminStatus = async () => {
        let isAdmin = await checkIfPortalAdmin(userId, currentStage) || await checkIfSupportAdmin(userId, currentStage);
        setIsAdminUser(isAdmin);
    };

    const handleAccess = async (data) => {
        let resp = false
        if (data[FLEXICO_TEMPLATE_KEYS.created_by] == userId) {
            resp = true
        } else {
            resp = await checkIfPortalAdmin(userId, currentStage)
            if(!resp){
                resp = await checkIfSupportAdmin(userId, currentStage)
            }

            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if (currentAppId == appSettings[currentStage].appId) {
                resp = false
            }

            if(!resp && currentAppId == appSettings[currentStage]['appId']){
                resp = await isCorpAdmin(userId,currentAppId,currentStage)
                resp = resp['admin']
            }
            if (!resp) {
                resp = await isUploaderAllowed(data, userId, currentStage)
            }
            if (!resp) {
                resp = await isApprover(data, userId, currentStage)
            }
        }

        setIsAuthorised(resp)
        setIsCheckingAccess(false)
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setShowLoadingIcon(true)
        // await getFlexicoTemplate(fid, async function onSuccess(response) {
        //     let res = response.data.getFlexicoTemplateRDS
        //     setFlexicoTemplateData(res)
        //     await handleAccess(res)
        //     await checkAdminStatus()
        //     setShowLoadingIcon(false);
        // }, function onFailure(response) {
        //     setShowLoadingIcon(false);
        //     setErrorMessage("Could not load template information")
        // })


        // await listFlexicoTransactionsByFlexIdAll(id, fid, 10000, null, function onSuccess(results){
        //     setTransactions(results)
        //     results.sort(function (a, b) {
        //         var dateA = new Date(Number(a.lastUpdatedTimestamp)), dateB = new Date(Number(b.lastUpdatedTimestamp));
        //         return dateB - dateA;
        //     });
        //     setItems(results)
        // })

        await Promise.all([
        new Promise((resolve, reject) => {
            getFlexicoTemplate(
            fid,
            async function onSuccess(response) {
                try {
                let res = response.data.getFlexicoTemplateRDS;
                setFlexicoTemplateData(res);
                await handleAccess(res);
                await checkAdminStatus();
                resolve();
                setShowLoadingIcon(false);
                } catch (e) {
                reject(e);
                }
            },
            function onFailure(response) {
                setShowLoadingIcon(false);
                setErrorMessage("Could not load template information");
                reject(response);
            }
            );
        }),

        new Promise((resolve, reject) => {
            listFlexicoTransactionsByFlexIdAll(
            id,
            fid,
            10000,
            null,
            function onSuccess(results) {
                setTransactions(results);
                results.sort(function (a, b) {
                var dateA = new Date(Number(a.lastUpdatedTimestamp)),
                    dateB = new Date(Number(b.lastUpdatedTimestamp));
                return dateB - dateA;
                });
                setItems(results);
                resolve();
            }
            );
        })
        ]);
            } finally {
        if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FLEXICO)
        }
    }
    
}

    const getParam= (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
      }

    const getTemplateDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.template_name], flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.label]);
    }

    const loadColumnPreferences = (onSuccess, onError) => {
        if (!fid) {
            onSuccess(null);
            return;
        }
        
        listPreference(
            fid,                        
            'FLEXICO',                  
            'HISTORY_COLUMN_PREF',      
            function onSuccessResponse(response) {
                const preferences = response?.data?.listPreference?.items || [];
                
                const validPreferences = preferences.filter(pref => {
                    if (pref.information) {
                        const information = typeof pref.information === 'string'
                            ? JSON.parse(pref.information)
                            : pref.information;
                        return information && information.columnState;
                    }
                    return false;
                });

                if (validPreferences.length > 0) {
                    const firstPreference = validPreferences[0];
                    setFullPreferenceObject(firstPreference);
                    const information = JSON.parse(firstPreference.information);
                    onSuccess(information?.columnState);
                } else {
                    setFullPreferenceObject(null);
                    onSuccess(null);
                }
            },
            function onFailureResponse(error) {
                setFullPreferenceObject(null);
                onError(error);
            }
        );
    };

    const saveColumnPreferences = (state) => {
        if (!fid || !state) return;

        setColumnPreferenceError("");
        setIsSavingColumnPreferences(true);

        const label = `Column preferences for Flexico ${fid}`;
        const information = {
            columnState: state
        };
        
        if (fullPreferenceObject?.preferenceId) {
            updatePreference(
                fullPreferenceObject.preferenceId,
                label,
                userId,
                information,
                () => {
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error updating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        } else {
            const newPreferenceId = uuidv4();
            createPreference(
                newPreferenceId,
                'HISTORY_COLUMN_PREF',
                label,
                fid,                 
                'FLEXICO',           
                userId,
                information,
                null,              
                (response) => {
                    const newPreference = {
                        preferenceId: newPreferenceId,
                        label: label,
                        associationId: fid,
                        associationIdType: 'FLEXICO',
                        preferenceType: 'HISTORY_COLUMN_PREF',
                        createdBy: userId,
                        lastUpdatedBy: userId,
                        lastUpdatedTimestamp: Date.now().toString(),
                        information: information
                    };
                    setFullPreferenceObject(newPreference);
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error creating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        }
    };

    const handleColumnEvent = () => {
        if (isInitialLoadComplete) {
            setHasColumnChanges(true);
        }
    };

    const handleColumnVisibilityEvent = () => {
        if (isInitialLoadComplete) {
            setHasColumnChanges(true);
        }
    };

    const onGridReady = (params) => {
        setIsInitialLoadComplete(true);
    };

    const handleSaveColumnLayout = () => {
        if (gridRef.current?.api) {
            const currentState = gridRef.current.api.getColumnState();
            const updatedColumnDefs = currentState
                .filter(col => !col.hide)
                .map(colState => {
                    return defaultColumnDefs.find(defCol => defCol.field === colState.colId);
                })
                .filter(Boolean);
            
            setColumnDefs(updatedColumnDefs);
            saveColumnPreferences(currentState);
        }
    };
    const resetColumnlayout = () => {
        if (gridRef.current?.api) {
            setColumnPreferenceError("");
            setIsResetting(true);
            
            setTimeout(() => {
                const defaultState = defaultColumnDefs.map((col, index) => ({
                    colId: col.field,
                    hide: false,
                    pinned: null,
                    sort: null,
                    sortIndex: null,
                    aggFunc: null,
                    width: col.width ? parseInt(col.width) : undefined,
                    flex: null,
                    rowGroupIndex: null,
                    pivotIndex: null
                }));
                
                gridRef.current.api.applyColumnState({
                    state: defaultState,
                    applyOrder: true
                });
                
                setColumnDefs(defaultColumnDefs);
                setHasColumnChanges(true);
                setIsResetting(false);
            }, 300); 
        }
    };

    const content = (
        <div>
            {
                isAuthorised?
                <Box>
                    <SpaceBetween size='l'>
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const executeTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'execute'
                                                );
                                                
                                                if (executeTab && executeTab.action) {
                                                    executeTab.action();
                                                } else {
                                                    history.push(`/App/${id}/flexico/${fid}/upload${location.search}`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/flexico/${fid}/upload${location.search}`);
                                            }
                                        }}>
                                            Execute
                                        </Button>
                                    </SpaceBetween>
                                }
                                description=""
                            >Execute job for template - {getTemplateDisplayName()}


                            </Header>
                        }
                    >
                    </Container>

                        <Container
                            header={
                                <Header
                                    variant='h2'
                                    actions={
                                        <SpaceBetween direction="horizontal" size="xs">
                            {hasColumnChanges && isAdminUser && (
                                <Button 
                                    variant='primary' 
                                    onClick={handleSaveColumnLayout}
                                    loading={isSavingColumnPreferences}
                                    disabled={isSavingColumnPreferences || isResetting}
                                >
                                    Save view
                                </Button>
                            )}
                                             <Button 
                                                variant='link' 
                                                onClick={resetColumnlayout}
                                                loading={isResetting}
                                                disabled={isSavingColumnPreferences || isResetting}
                                            >
                                                Reset view
                                            </Button>
                                            <Button variant='normal' iconName='refresh' onClick={loadData}></Button>
                                        </SpaceBetween>
                                    }
                                    description="The following table shows all the executions."
                                >Execution history
                                    {showLoadingIcon ?
                                        <Spinner size='normal'></Spinner> : <div></div>
                                    }

                                </Header>
                            }
                            fitHeight
                        >
                            {columnPreferenceError && (
                                <Box margin={{ bottom: "s" }}>
                                    <StatusIndicator type="error">{columnPreferenceError}</StatusIndicator>
                                </Box>
                            )}
                            <div
                                className="ag-theme-alpine"
                                style={{ height: 400, width: "100%" }}
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={items}
                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}
                                    rowSelection='single'
                                    animateRows={true}
                                    rowHeight={40}
                                    enableCellTextSelection={true}
                                    onColumnMoved={handleColumnEvent}
                                    onColumnVisible={handleColumnVisibilityEvent}
                                    onGridReady={onGridReady}
                                    pagination={true}
                                    paginationPageSize={20}
                                    paginationPageSizeSelector={[10, 20, 50, 100]}
                                    suppressPaginationPanel={false}
                                >
                                </AgGridReact>
                            </div>
                        </Container>
                    </SpaceBetween>
                    <Modal
                onDismiss={() => {
                    setParametersVisible(false)
                    setParametersModalData('')
                }}
                visible={parametersVisible}
                size="max"
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="primary" onClick={() => {
                                setParametersVisible(false)
                                setParametersModalData('')
                            }}>
                                Close
                            </Button>
                        </SpaceBetween>
                    </Box>
                }
            >
                <CodeView
      content={parametersModalData}
    />
            </Modal>
                    </Box> : isCheckingAccess ? <div>
                        <WaitForPageAccess></WaitForPageAccess>
                    </div> :
                        <Alert
                            statusIconAriaLabel="Error"
                            type="error"
                            header="Access denied"
                        >
                             {
                                currentAppId == appSettings[currentStage]['appId'] ?
                                "You don't have permission to view the history. You are not part of the Uploader/Approver group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group":
                                "No access to view"

                            }
                        </Alert>
            }
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/flexico/${fid}/history`} id={id} fid={fid} process={flexicoTemplateData} back={backUrl}/> }
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
        ></AppLayout>
    )
}



export default FlexicoHistory
